<!--
 * @Author: 仙道
 * @Date: 2022-08-14 21:09:45
 * @LastEditTime: 2022-08-28 12:06:15
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/jeecg/LinkToDetail.vue
-->
 
<template>
  <span>
    <!-- <a-button
      :key="item"
      @click="toDetail(item)"
      type="link"
      v-bind="$attrs"
      v-for="(item,index) in splitIds"
      v-if="eleType=='button'"
    >
      <slot v-if="!splitText||splitText.length===0"></slot>
      <span v-else>{{splitText[index]}}</span>
    </a-button>-->
    <a :key="item" @click="toDetail(item)" style="margin-right:5px;" v-for="(item,index) in splitIds">
      <slot v-if="!splitText||splitText.length===0"></slot>
      <span v-else>{{splitText[index]}}</span>
    </a>
  </span>
</template>

<script>

  export default {
    name: 'LinkToDetail',
    props: {
      eleType: {
        type: String,
        default: 'button'
      },
      routeName: {
        type: String,
        default: ''
      },
      pageType: {
        type: String,
        default: 'page'
      },
      id: {
        type: String,
        default: ''
      },
      record: {
        type: Object,
        default: () => { }
      },
      text: {
        type: String,
        default: ''
      }

    },
    components: {

    },
    computed: {
      splitIds () {
        return this.id?.split(',')
      },
      splitText () {
        return this.text ? this.text.split(',') : []
      }
    },
    // 定义属性
    data () {
      return {

      }
    },

    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      toDetail (id) {
        if (!this.routeName || !id) {
          this.$message.error('请检查跳转参数')
        }
        this.$bus.$emit('to-page-detail', {
          name: this.routeName,
          id: id,
          type: this.pageType
        })
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>